import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function admins(state = initialState, action) {
  switch (action.type) {
    case actions.SET_ADMINS:
      //console.log('[admins][payload]', action.payload);
      if (action.payload.list) {
        return action.payload.list;
        //return [...action.payload.list];
      } else {
        return state;
      }
    default:
      return state;
  }
}
